import { PropsWithChildren } from 'react';

import { FormSubmit } from 'libs/form';

import { TimezoneFormType, Form, getSchema } from '../../forms/timezoneForm';

export interface TimezoneFormProps {
  initialValues?: Partial<TimezoneFormType>;
  onSubmit: FormSubmit<TimezoneFormType>;
}

export const TimezoneSettingsForm = ({
  initialValues,
  children,
  onSubmit,
}: TimezoneFormProps & PropsWithChildren) => {
  const schema = getSchema();

  return (
    <Form
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {children}
    </Form>
  );
};
